import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMoreButton = ({ fill = '#FE5000', ...props }: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill={fill} {...props}>
    <path fill={fill} d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0M4 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0M16 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0" />
  </svg>
);
export default SvgMoreButton;
